import { bootstrapApplication } from '@angular/platform-browser';
import { initializeSentry, releaseVersion } from '@thiememeulenhoff/ng-sdk';
import { setGlobalConfig } from '@thiememeulenhoff/js-sdk';
import { Environment } from '@thiememeulenhoff/types';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

import '@thiememeulenhoff/albert';

initializeSentry(
  'https://cd20432b17ea838275ed5eef853a639e@o1127103.ingest.us.sentry.io/4512010642194432',
  {
    enabled: environment.environment === Environment.Production,
    environment: environment.environment,
    release: releaseVersion(),
    replaysSessionSampleRate: 0,
    unleash: true,
  },
);

setGlobalConfig({
  environment: environment.auth.environment,
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [...appConfig.providers],
}).catch((err) =>
  // eslint-disable-next-line no-console
  console.error(err),
);
